"use strict";
exports.__esModule = true;
exports.EMBED_NOT_COVERED = exports.EMBED_START_PAYMENT = exports.EMBED_SUSPENDED = exports.EMBED_PROPERTY_MISMATCH = exports.EMBED_SOMETHING_WENT_WRONG = exports.EMBED_SERVICE_ISSUE = exports.EMBED_BLOCK_RXP = exports.EMBED_INVALID_PRODUCT = exports.EMBED_ALREADY_FLEXING_YOUR_RENT = exports.EMBED_RENT_SPLIT_PROGRESS = exports.EMBED_NOT_RENT_DAY = void 0;
exports.EMBED_NOT_RENT_DAY = {
    BODY: 'Starting {{ bpDate }}, you’ll be able to split your {{ bpMonth }} rent right here or in the Flex app.',
    HEADER: "It's not rent day yet!",
    NOTICE: 'Download the Flex app to manage your account, adjust payment options and receive important notifications. '
};
exports.EMBED_RENT_SPLIT_PROGRESS = {
    BODY: 'Flex is handling your rent this month–you’ll be notified when your payments are completed. ',
    HEADER: 'Rent split in progress',
    NOTICE: 'In the meantime, you can check your status and manage payments in the Flex app.'
};
exports.EMBED_ALREADY_FLEXING_YOUR_RENT = {
    HEADER: 'Your {{bpMonth}} rent will be split automatically',
    LIST_ITEM_HEADER: 'Here’s what to expect',
    LIST_ITEM_1: 'Your 1st payment will be processed once rent is posted',
    LIST_ITEM_2: 'Flex submits your full rent directly to your property when it’s due',
    LIST_ITEM_3: 'Your 2nd payment will be pulled on your scheduled date ',
    NOTICE: 'Manage your account and receive important notifications in the Flex app.'
};
exports.EMBED_INVALID_PRODUCT = {
    BODY: 'Your account isn’t currently set up to use Flex within your rent portal. You’ll need to use the Flex app instead.',
    HEADER: 'Flex your rent in the app',
    NOTICE: 'Download and head to the Flex app to continue, track your status, or manage your account.'
};
exports.EMBED_BLOCK_RXP = {
    BODY: 'It looks like you started signing up for Flex in the mobile app or browser. To finish, you’ll need to resume onboarding in the Flex mobile app or in your browser.',
    HEADER: 'Your signup isn’t complete',
    CTA: 'Download and open the Flex app to continue, or follow this '
};
exports.EMBED_SERVICE_ISSUE = {
    BODY: 'Make sure your property has posted your rent bill and it looks accurate to pay with Flex.',
    HEADER: 'Issue with your rent bill',
    NOTICE: 'See more details and help us resolve the problem in the Flex app.'
};
exports.EMBED_SOMETHING_WENT_WRONG = {
    BODY: 'You aren’t eligible to split your rent right now.',
    HEADER: 'Something went wrong',
    NOTICE: 'See more details and manage your account in the Flex app.'
};
exports.EMBED_PROPERTY_MISMATCH = {
    BACK: 'Back',
    BODY_1: 'Your current property doesn’t match the information we got from your rent portal. You’ll need to use the Flex app to split your rent or connect your account to the property on the previous screen.',
    BODY_2: 'Head to the Flex app to track your status and manage your account.',
    HEADER: 'Flex your rent in the app'
};
exports.EMBED_SUSPENDED = {
    BODY: 'Your membership has been suspended due to an outstanding balance. To continue using Flex, please pay off your balance to Flex.',
    HEADER: 'Your Flex membership has been suspended',
    NOTICE: 'Manage your account and pay off your balance in the Flex app.'
};
exports.EMBED_START_PAYMENT = {
    CTA: 'Split rent',
    BODY: 'You can now split your {{bpMonth}} rent. Make your 1st payment here or you can process it in the Flex app.',
    HEADER: 'It’s rent day!'
};
exports.EMBED_NOT_COVERED = {
    BODY: 'You will need to pay your rent yourself this month. Come back on {{ bpDate }} to split your {{ bpMonth }} rent right here or in the Flex app.',
    HEADER: 'You are not using Flex this month ',
    NOTICE: 'Download the Flex app to manage your account, adjust payment options and receive important notifications. '
};
